import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import {
  IS_HUB_ENTERPRISE_OR_HUB_LITE,
  IS_HUB_LITE,
  ON_PREM_DOCS_URL,
  PRODUCT_DOCS_URL,
} from '@core/hubconfig';
import { ApplicationMode } from '@core/interfaces/application';
import { Flags } from '@core/interfaces/feature-flags';
import { FeatureFlagsService } from '@core/services/feature-flags/feature-flags.service';
import { HubDestroyService } from '@core/services/hub-destroy/hub-destroy.service';
import { TenantsStoreService } from '@core/services/tenants/tenants-store.service';
import { AppState } from '@core/store/application/application.state';
import { ToggleDesignerAssistant } from '@core/store/designer-assistant/designer-assistant.actions';
import { UserState } from '@core/store/user/user.state';
import { filterDefined } from '@core/utils/filter-defined';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngxs/store';
import { HubButtonComponent } from '@shared/atoms/hub-button/hub-button.component';
import { OperationToastsComponent } from '@shared/atoms/hub-operation-toasts/operation-toasts';
import { MainHeaderNotificationsComponent } from '@shared/features/hub-main-header/main-header-notifications/main-header-notifications.component';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'hub-main-header-actions',
  imports: [
    HubButtonComponent,
    MainHeaderNotificationsComponent,
    NgbTooltip,
    OperationToastsComponent,
  ],
  templateUrl: './main-header-actions.component.html',
  styleUrl: './main-header-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [HubDestroyService],
  host: { class: 'hub-d-flex hub-justify-content-end hub-align-items-center' },
})
export class MainHeaderActionsComponent implements OnInit {
  readonly mode = select(AppState.mode);
  readonly user = select(UserState.user);
  readonly isLicensePortal = signal(false);

  readonly isDesignerAssistantEnabled = computed(() =>
    this.featureFlagService.isFeatureEnabled(Flags.DESIGNER_ASSISTANT),
  );

  protected readonly docsUrl = IS_HUB_ENTERPRISE_OR_HUB_LITE ? ON_PREM_DOCS_URL : PRODUCT_DOCS_URL;
  protected readonly IS_LITE = IS_HUB_LITE;
  protected readonly applicationMode = ApplicationMode;
  private readonly hubDestroyService = inject(HubDestroyService);
  private readonly tenantsStoreService = inject(TenantsStoreService);
  private readonly featureFlagService = inject(FeatureFlagsService);
  private readonly store = inject(Store);

  ngOnInit(): void {
    this.tenantsStoreService.isLicensePortal$
      .pipe(
        filterDefined<boolean>(),
        distinctUntilChanged(),
        this.hubDestroyService.takeUntilDestroy(),
      )
      .subscribe((isLicensePortal) => {
        this.isLicensePortal.set(isLicensePortal);
      });
  }

  toggleDesignerAssistant(): void {
    this.store.dispatch(new ToggleDesignerAssistant());
  }
}
